import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from '@/App.jsx'
import { ErrorBoundary } from '@/ErrorBoundary.jsx'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClientInstance } from '@/lib/query-client'
import '@/styles/design-system.css'
import '@/index.css'
import '@/styles/theme-light.css'
import { initSimulateChannelsFromUrl } from '@/lib/dev/simulateAllChannelsConnected.js'

// TEMPORARY DEV/TEST TOOL — ?simulate=on|off (see simulateAllChannelsConnected.js)
initSimulateChannelsFromUrl()

async function mountApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'))
  const boundary = (node) => (
    <ErrorBoundary>
      <Sentry.ErrorBoundary fallback={<div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>Something went wrong</h1>
        <p>The error has been reported. Please refresh the page.</p>
        <button type="button" onClick={() => window.location.reload()} style={{ marginTop: '1rem', padding: '0.5rem 1rem', cursor: 'pointer' }}>
          Refresh
        </button>
      </div>}>
        {node}
      </Sentry.ErrorBoundary>
    </ErrorBoundary>
  )

  if (import.meta.env.DEV && window.location.pathname === '/dev/chat-blocks-smoke') {
    const { default: ChatBlocksSmoke } = await import('@/pages/dev/ChatBlocksSmoke.jsx')
    root.render(boundary(
      <QueryClientProvider client={queryClientInstance}>
        <ChatBlocksSmoke />
      </QueryClientProvider>,
    ))
    return
  }

  root.render(boundary(<App />))
}

// ---------------------------------------------------------------------------
// Sentry — initialize before rendering (DSN from Vercel env var)
// ---------------------------------------------------------------------------
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
  })
}

mountApp()
